// @ts-nocheck
/* ══════════════════════════════════════════════════════════════
   REYNA — responsive video source

   Picks a mobile or desktop file for the same <video> element and
   only ever downloads the one it needs.

   Rendering two <video> tags and hiding one with CSS would still let
   the hidden file download, so the markup ships with no <source> at
   all and this sets it once the viewport is known.

   Markup contract:
     <video data-responsive-video
            data-src-desktop="…"
            data-src-mobile="…"      (optional — falls back to desktop)
            data-breakpoint="768">   (optional — defaults to 768)
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function apply(video) {
    var desktop = video.getAttribute('data-src-desktop') || '';
    var mobile = video.getAttribute('data-src-mobile') || '';
    var bp = parseInt(video.getAttribute('data-breakpoint'), 10) || 768;

    var wantMobile = window.matchMedia('(max-width: ' + bp + 'px)').matches;
    var src = wantMobile && mobile ? mobile : desktop;
    if (!src) return;

    // Nothing to do if this source is already playing.
    if (video.getAttribute('data-current-src') === src) return;
    video.setAttribute('data-current-src', src);

    video.innerHTML = '';
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();

    // autoplay + muted is honoured on load(); ignore the promise rejection
    // browsers throw when the tab is backgrounded.
    if (video.hasAttribute('autoplay')) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-responsive-video]'), apply);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  /* Swap on a real breakpoint crossing — e.g. rotating a tablet. Debounced so
     a drag-resize doesn't restart the file on every frame. */
  var timer = null;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { boot(); }, 250);
  });

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
